import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRelationArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 165,
	height: 30,
	viewBox: "0 0 165 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector 2",
		d: "M0.5 28.9614C0.5 29.2376 0.723858 29.4614 1 29.4614C1.27614 29.4614 1.5 29.2376 1.5 28.9614H0.5ZM160.646 29.315C160.842 29.5102 161.158 29.5102 161.354 29.315L164.536 26.133C164.731 25.9377 164.731 25.6212 164.536 25.4259C164.34 25.2306 164.024 25.2306 163.828 25.4259L161 28.2543L158.172 25.4259C157.976 25.2306 157.66 25.2306 157.464 25.4259C157.269 25.6212 157.269 25.9377 157.464 26.133L160.646 29.315ZM1.5 28.9614V9H0.5V28.9614H1.5ZM9 1.5H153V0.5H9V1.5ZM160.5 9V28.9614H161.5V9H160.5ZM153 1.5C157.142 1.5 160.5 4.85786 160.5 9H161.5C161.5 4.30558 157.694 0.5 153 0.5V1.5ZM1.5 9C1.5 4.85786 4.85786 1.5 9 1.5V0.5C4.30558 0.5 0.5 4.30558 0.5 9H1.5Z",
		fill: "#D1D3DB"
	})
});
export default SvgRelationArrow;
